export interface ScoreResult {
  total: number;
  stars: 1 | 2 | 3;
  accuracy: number;
  timeBonus: number;
  streakBonus: number;
}

export function calculateScore(
  correct: number,
  total: number,
  timeInSeconds: number,
  bestStreak: number
): ScoreResult {
  const basePoints = correct * 10;
  const streakBonus = bestStreak * 2;
  const timeBonus = Math.max(0, 600 - (timeInSeconds * 2));
  const accuracy = (correct / total) * 100;
  
  const totalScore = basePoints + streakBonus + timeBonus;
  
  let stars: 1 | 2 | 3;
  if (accuracy >= 90 && timeInSeconds < 120) {
    stars = 3;
  } else if (accuracy >= 70) {
    stars = 2;
  } else {
    stars = 1;
  }
  
  return {
    total: totalScore,
    stars,
    accuracy,
    timeBonus,
    streakBonus
  };
}